import { i18n } from '@/i18n'

export const fieldRequiredByBlur = {
  required: true, message: i18n.t('required'), trigger: ['blur'],
}

export const fieldRequiredByBlurAndChange = {
  required: true, message: i18n.t('required'), trigger: ['blur', 'change'],
}
